<template>

<div class="container is-child" style="margin-top:15px;">

        <div class="table__wrapper is-child">
          <table class="table is-child is-fullwidth" style="overflow-x: auto;">
            <thead>
              <th v-for="heading in headers" v-bind:key="heading" >
                {{heading}}
              </th>
            </thead>
            <tbody>
              <tr  v-for="row in tableData" v-bind:key="row.id">
                <td v-for="data in row" v-bind:key="data.id">{{data}}</td>
              </tr>
            </tbody>
          </table>
        </div>
  </div>
</template>
<script>
export default {
  props: ['heading', 'headers', 'tableData', 'total'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // console.log('Edit Table Data is: ' + this.total)
  }
}
</script>
<style>
.table__wrapper {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// sub-table.vue?6139baec